
import { api_host, api_auth} from '../../common/globals/constants';

export const getSummaryDayWeek= (objective, user, token, begin, final, schedule) => 
    fetch(api_host+`/reporte/online/indicadores/ResponseTimePerHour/SummaryDayWeek/?user=${user}&objetivoId=${objective}&t=c&begin=${begin}&final=${final}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}&key=${api_auth}&horarioId=${schedule}`)
.then(response => response.json())

export const getSummaryDayWeekTable = (objective, user, token, begin, final, schedule) => 
    fetch(api_host+`/reporte/online/indicadores/ResponseTimePerHour/SummaryDayWeekTable/?user=${user}&objetivoId=${objective}&t=c&begin=${begin}&final=${final}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}&key=${api_auth}&horarioId=${schedule}`)
.then(response => response.json())

